<template>
  <div class="app">
    <version-checker :PFX="PROJ_PFX" :bundleVersion="appInfo.version"></version-checker>
    <LoaderBar></LoaderBar>
    <div class="app__main"
         :class="{'app__main--disableSelect': $store.state.appInterface.disableSelect}">
      <relogin-on-fly style="animation-duration: 0.15s"
                      @login-canceled="onReloginCancel()"
                      @login-success="onReloginSuccess()"
      ></relogin-on-fly>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import Cookies from 'js-cookie'
  import ReloginOnFly from './components/ReloginOnFly/ReloginOnFly.vue'
  import auth from 'src/services/auth'
  import localStorageTransport from './services/localStorageTransport'
  import LoaderBar from './components/LoaderBar/LoaderBar'
  // import NotifyTest from './notifyTest.vue'
  // Loading some plugin css asynchronously

  import packagejson from '@/lib/packagejson'

  import versionChecker from '@/plugins/VersionChecker/VersionChecker.vue'
  import {PROJ_PFX, LANG} from '@/constants'
  import globvars from '@/lib/globvars'
  export default {
    name: 'App',
    components: {
      versionChecker,
      ReloginOnFly,
      LoaderBar
      // NotifyTest
    },
    watch: {
      $route () {
        setTimeout(() => {
          this.$root.$emit('resetScroll')
          this.$root.$emit('focusOnContent')
        }, 150)
      },
      bodyMaximized (val) {
        if (val) {
          document.querySelector('body').classList.add('bodyMaximized');
        } else {
          document.querySelector('body').classList.remove('bodyMaximized');
        }
      }
    },
    data () {
      return {
        PROJ_PFX,
        visibleReloginOnFly: false,
        appInfo: packagejson.getKeys()
      }
    },
    onActive () {},
    methods: {
      onReloginCancel () {
        this.visibleReloginOnFly = false
      },
      onReloginSuccess () {
        this.visibleReloginOnFly = false
        this.$root.$emit('on-login')
      },
      relogin () {
        if (this.$route.path !== '/login') {
          this.visibleReloginOnFly = true
          this.$store.dispatch('user/logout')
          this.$root.$emit('relogin')
        }
      },
      makeAppInfoLog () {
        console.log('name:', this.appInfo.name)
        console.log('version:', this.appInfo.version)
      }
    },
    computed: {
      user () {
        return this.$store.state.user.user
      },
      bodyMaximized () {
        return this.$store.state.bodyMaximized
      }
    }
  }
</script>
<style lang="scss">
  $animationDuration: 0.24s;
  @import "~vue2-animate/src/sass/vue2-animate.scss";

  @import "./assets/fonts/Roboto/stylesheet";

  @import "./assets/styles/scss/typography";
  // library imports
  @import './assets/sass/paper-dashboard.scss';
  @import './assets/sass/element_variables.scss';
  @import './assets/sass/demo.scss';
  @import './assets/sass/print.scss';

  .el-select-dropdown__list .el-select-dropdown__item {
    max-width: 238px;
    height: auto;
    line-height: 1.2;
    padding-top: 10px;
    padding-bottom: 10px;
    overflow: visible;
    white-space: normal;
    text-overflow: unset;

    .bodyMaximized & {
      max-width: 344px;
    }
  }

  .active-form__col, .user-list-filters__filter {
    .el-select__tags-text {
      display: inline-block;
      max-width: 165px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

    .bodyMaximized & {
      max-width: 271px;
    }
    }
    .el-tag__close.el-icon-close {
      margin-top: -16px;
    }
  }

  html, body {
    height: 100%;
    overflow: hidden;
  }

  body {
    min-height: 100vh;
  }

  .app {
    display: flex;
    flex-flow: column;
    height: 100%;
    overflow: hidden;

    &__main {
      flex: 1;
      display: flex;
      overflow: auto;

      &--disableSelect {
        * {
          user-select: none;
          -webkit-user-select: none;
        }
      }
    }
  }

  .notifications.vue-notifyjs {
    .notification-list-move {
      transition: transform 0.3s, opacity 0.4s;
    }

    .notification-list-item {
      display: inline-block;
      margin-right: 10px;

    }

    .notification-list-enter-active, .notification-list-leave-active {
      transition: opacity 0.4s;
    }

    .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
    {
      opacity: 0;
    }
  }

  .el-tabs__nav-scroll {
    overflow: auto;
  }

  .blur {
    -webkit-filter: blur(8px);
    -moz-filter: blur(8px);
    filter: blur(8px);
    filter: progid:DXImageTransform.Microsoft.Blur(pixelRadius=8);
    overflow: hidden;
    transform: translateZ(0);
  }

</style>